'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _recompose = require('recompose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

function createGuardedContainer(_ref) {
  var _dec, _class, _desc, _value, _class2, _class3, _temp2;

  var permissionName = _ref.permissionName,
      enabledComponent = _ref.enabledComponent,
      _ref$disabledComponen = _ref.disabledComponent,
      disabledComponent = _ref$disabledComponen === undefined ? (0, _recompose.renderNothing)() : _ref$disabledComponen,
      _ref$shouldAlwaysUpda = _ref.shouldAlwaysUpdate,
      shouldAlwaysUpdate = _ref$shouldAlwaysUpda === undefined ? false : _ref$shouldAlwaysUpda;
  var GuardedContainer = (_dec = (0, _mobxReact.inject)('SessionStore'), _dec(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
    _inherits(GuardedContainer, _Component);

    function GuardedContainer() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, GuardedContainer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = GuardedContainer.__proto__ || Object.getPrototypeOf(GuardedContainer)).call.apply(_ref2, [this].concat(args))), _this), _this.shouldComponentUpdate = shouldAlwaysUpdate ? function (nextProps, nextState) {
        return true;
      } : undefined, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(GuardedContainer, [{
      key: 'render',
      value: function render() {
        var passThroughProps = (0, _omit3.default)(this.props, 'SessionStore'),
            Component = this.userHasPermission ? enabledComponent : disabledComponent;

        return _react2.default.createElement(Component, passThroughProps);
      }
    }, {
      key: '__reactstandin__regenerateByEval',
      // @ts-ignore
      value: function __reactstandin__regenerateByEval(key, code) {
        // @ts-ignore
        this[key] = eval(code);
      }
    }, {
      key: 'userHasPermission',
      get: function get() {
        var SessionStore = this.props.SessionStore,
            permissions = (0, _isString3.default)(permissionName) ? [permissionName] : permissionName;


        return permissions.some(SessionStore.userHasPermission);
      }
    }]);

    return GuardedContainer;
  }(_react.Component), _class3.displayName = 'GuardedContainer(' + (0, _recompose.getDisplayName)(enabledComponent) + ')', _class3.enabledComponent = enabledComponent, _class3.propTypes = {
    SessionStore: _propTypes2.default.object.isRequired
  }, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'userHasPermission', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'userHasPermission'), _class2.prototype)), _class2)) || _class) || _class);


  return GuardedContainer;
}

var _default = createGuardedContainer;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(createGuardedContainer, 'createGuardedContainer', '/app/src/containers/GuardedContainer.js');
  reactHotLoader.register(_default, 'default', '/app/src/containers/GuardedContainer.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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